import React, {useContext, useEffect, useState} from "react";
import styles from './ProjectMain.module.scss';
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import {isFundRaising, isOverdue, OrderDetails, translateProjectStatus} from "../../../../api-client";
import {Loader, Money} from "../../../common";
import {createOrdersProvider} from "../../../../di";
import {useErrorCallback, useLoading} from "../../../../hooks";
import apiClientConfig from "../../../../configs/app";
import {Environment} from "../../../../utils";
import ProjectGallery from "../ProjectGallery";
import ProjectStatsRow from "../ProjectStatsRow";
import ProjectMainInfo from "../ProjectMainInfo";
import {formatDate} from "../../../../formatters";
import {
  getProjectGalleryImages,
  getProjectVideoUrl,
  isSocialProject
} from "../../../../utils/pages";

const ProjectMain = () => {
  const project = useContext(DetailedProjectContext).project;
  const errorCallback = useErrorCallback();
  const [loading, withLoading] = useLoading();
  const [order, setOrder] = useState<OrderDetails>();

  useEffect(() => {
    const callback = async () => {
      try {
        const provider = await createOrdersProvider();
        const order = await provider.getOne(project.uuid!);
        setOrder(order);
      } catch (error) {
        if (error instanceof Error) {
          await errorCallback(error);
        }
      }
    };
    (async () => {
      await withLoading(callback);
    })();
  }, []);


  const devAndTest = (apiClientConfig.applicationEnvironment === Environment.dev)
        || (apiClientConfig.applicationEnvironment === Environment.test);

  const isSocial = isSocialProject(project);
  const images = getProjectGalleryImages(project);

  if (loading) return <Loader/>;
  return (<>
    <div className={styles.detailedProjectMain}>
      <div className={styles.detailedProjectMain__top}>
        {project.paymentCode ? (
          <div className={styles.detailedProjectMain__tag}>
            {project.paymentCode}
          </div>
        ) : null}
        <div className={
          isFundRaising(project.status)
            ? styles.detailedProjectMain__surety
            : isOverdue(project.status)
              ? styles.detailedProjectMain__earlyRepayment
              : styles.detailedProjectMain__tag
        }>
          {translateProjectStatus(project.status)}
        </div>
        <div className={styles.detailedProjectMain__tag}>
          Заем
        </div>
        {project.debt.hasSurety ? (
          <div className={styles.detailedProjectMain__surety}>
            Поручительство
          </div>
        ) : null}
        {project.debt.hasCollateral ? (
          <div className={styles.detailedProjectMain__earlyRepayment}>
            Залог
          </div>
        ) : null}
        {project.tags.map((tag) => (
          <div
            key={tag.uuid}
            className={styles.detailedProjectMain__tag}
            style={tag.color ? {color: tag.color} : undefined}
          >
            {tag.name}
          </div>
        ))}
      </div>
      <div className={styles.detailedProjectMain__project}>
        <div>
          <p className={styles.detailedProjectMain__name}>
            {project.name[0].text}
          </p>
          {!isSocial && <p className={styles.detailedProjectMain__info}>
            Срок действия инвестиционного предложения
            с {formatDate(project.investOfferDate)} до {formatDate(project.maturityDate)}
          </p>}
        </div>
        {devAndTest && <div>
          <div className={styles.detailedProjectMain__oredrsSum}>
            <span className={styles.detailedProjectMain__oredrsSum__text}>Сумма ваших заявок: </span>
            <Money money={order?.investment || {amount: 0, currencyCode: 'RUB'}}/>
          </div>
        </div>}
      </div>

      {isSocial ? (
        <>
          <ProjectGallery
            images={images}
            videoUrl={getProjectVideoUrl(project)}
          />
          <ProjectStatsRow/>
        </>
      ) : (
        <>
          <ProjectMainInfo/>
          <ProjectStatsRow/>
        </>
      )}
    </div>
  </>
  );
};

export default ProjectMain;